'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$57() {
  this.bkr = null;
  this.bks = false;
}
export { $c_Lpresto_PrestoRouter$$anon$57 as $c_Lpresto_PrestoRouter$$anon$57 };
$p = $c_Lpresto_PrestoRouter$$anon$57.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$57;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$57() {
}
export { $h_Lpresto_PrestoRouter$$anon$57 as $h_Lpresto_PrestoRouter$$anon$57 };
$h_Lpresto_PrestoRouter$$anon$57.prototype = $p;
$p.P = (function() {
  if ((!this.bks)) {
    this.bkr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bks = true;
  }
  return this.bkr;
});
var $d_Lpresto_PrestoRouter$$anon$57 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$57, "presto.PrestoRouter$$anon$57", ({
  Oo: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$57 as $d_Lpresto_PrestoRouter$$anon$57 };
//# sourceMappingURL=presto.-Presto-Router$$anon$57.js.map
